// 全局参数配置
// console.log('process.en', process.env);
export default {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: process.env.BASE_URL,
  PORTAL_DOMAIN: process.env.PORTAL_DOMAIN,
  ENVIRONMENT: process.env.ENVIRONMENT,
  A1_PORTAL: process.env.A1_PORTAL,
  DASHBOARD_URL: process.env.DASHBOARD_URL,
  DASHBOARD_BUDGET_URL: process.env.DASHBOARD_BUDGET_URL,
  DASHBOARD_MEETING_URL: process.env.DASHBOARD_MEETING_URL,
  DASHBOARD_SCORE_URL: process.env.DASHBOARD_SCORE_URL
};



// WEBPACK FOOTER //
// ./src/global/global.js